import makeStyles from '@mui/styles/makeStyles';
import colors from '../../styles/colors';

interface StylesProps {
  canViewMore: boolean;
  isViewingMore: boolean;
}

export const useStyles = makeStyles((theme) => ({
  label: {
    color: colors.blue.l45,
    fontSize: '14px',
    lineHeight: '20px',
    fontWeight: 500,
  },
  subLabel: {
    color: colors.gray.l30,
    fontSize: '12px',
    lineHeight: '20px',
    fontWeight: 400,
    letterSpacing: '0.1px',
  },
  linkList: {
    marginTop: theme.spacing(2),
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
    gridGap: theme.spacing(2),
    overflow: 'hidden',
    maxHeight: ({ canViewMore, isViewingMore }: StylesProps) => {
      return !canViewMore || isViewingMore ? 'fit-content' : '208px';
    },
  },
  linkWrapper: {
    '&:hover': {
      cursor: 'pointer',
      '& h3': {
        textDecoration: 'underline',
      },
    },
    '& a': {
      textDecoration: 'none',
    },
  },
  viewMore: {
    display: 'flex',
    justifyContent: 'center',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '20px',
    marginTop: '20px',
    textAlign: 'center',
    '& svg': {
      height: '20px',
    },
    '&:hover': {
      cursor: 'pointer',
    },
  },
}));
